<ng-container *ngIf="(copyStage$ | async) === copyStage.Unselected">
  <ng-container *ngIf="(disabled | async) === false">
    <button mat-icon-button class="enabled" (click)="addStepClick.emit(); addStepClicked()">
      <mat-icon>add</mat-icon>
    </button>
  </ng-container>
</ng-container>
<ng-container *ngIf="(copyStage$ | async) === copyStage.Selected">
  <button
    class="paste-button"
    mat-stroked-button
    (click)="isCopying = true; pasteStepClick.emit({ branch: branch, precedingSteps: precedingSteps })"
    [disabled]="isCopying"
  >
    <ng-container *ngIf="isCopying === false">
      {{ 'AUTOMATIONS.EDITOR.ADD_STEP.PASTE_HERE' | translate }}
    </ng-container>
    <div class="copying-loading-spinner" *ngIf="isCopying === true">
      <glxy-loading-spinner [size]="'small'" [fullWidth]="true"></glxy-loading-spinner>
    </div>
  </button>
</ng-container>
